import { defineComponent as _defineComponent } from 'vue'
import { Address } from '@/models/Address';
import { EventOrganizer } from '@/models/EventOrganizer';
import { Location } from '@/models/Location';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalTypeIcon',
  props: {
    addressRecord: {
        type: [Address, EventOrganizer, Location],
        required: true,
    },
    size: {
        type: [String, Number],
        default: '',
    },
},
  setup(__props) {



return { __sfc: true, }
}

})